module.exports = __webpack_public_path__ + "img/cloud-lightning.12c71547.svg";